import React from 'react'
import { Card, makeStyles, Typography } from '@material-ui/core'
import { People } from '@material-ui/icons'
import { Box } from '@mui/material'
import { colors } from 'utils/colors'
import { useDispatch } from 'react-redux'
import subjectSlice from 'store/subject'
import { SubjectStatus, SubjectType } from 'constants/index'

const SubjectCard = ({ title, type, speakerCanUploadTalks, subjectCount, selectedType }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  return (
    <Card
      elevation={0}
      variant="outlined"
      className={selectedType === type ? classes.selectedPaper : classes.paper}>
      <Box
        onClick={() => {
          dispatch(subjectSlice.actions.setSubjectType(type))
          if (subjectCount.pending > 0) {
            dispatch(subjectSlice.actions.setSubjectStatusFilter(SubjectStatus.INVITE_NOT_SENT))
          } else if (subjectCount.inReview > 0) {
            dispatch(subjectSlice.actions.setSubjectStatusFilter(SubjectStatus.PENDING_DATA_REVIEW))
          } else if (subjectCount.invited > 0) {
            dispatch(subjectSlice.actions.setSubjectStatusFilter(SubjectStatus.AWAITING_RESPONSE))
          } else if (subjectCount.approved > 0) {
            dispatch(subjectSlice.actions.setSubjectStatusFilter(SubjectStatus.APPROVED))
          } else {
            dispatch(subjectSlice.actions.setSubjectStatusFilter('All'))
          }
        }}>
        <Typography className={classes.title}>
          <People />
          {title}
        </Typography>

        <Box sx={{ marginTop: '10px', gap: '0.3rem' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <Box className={classes.info}>
              <Typography className={classes.label}>Invite not sent : </Typography>
              <Typography className={subjectCount?.pending > 0 ? classes.errorValue : ''}>
                {subjectCount?.pending}
              </Typography>
            </Box>
            <Box className={classes.info}>
              <Typography className={classes.label}>Awaiting response : </Typography>
              <Typography className={subjectCount?.invited > 0 ? classes.errorValue : ''}>
                {subjectCount?.invited}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <Box className={classes.info}>
              <Typography className={classes.label}>Pending review : </Typography>
              <Typography className={subjectCount?.inReview > 0 ? classes.errorValue : 'null'}>
                {subjectCount?.inReview}
              </Typography>
            </Box>
            <Box className={classes.info}>
              <Typography className={classes.label}>Approved : </Typography>
              <Typography className={subjectCount?.approved > 0 ? classes.successValue : 'null'}>
                {subjectCount?.approved}
              </Typography>
            </Box>
          </Box>

          {type === SubjectType.SPEAKER && speakerCanUploadTalks && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              {type === SubjectType.SPEAKER && (
                <Box className={classes.info}>
                  <Typography className={classes.label}>Awaiting Talks : </Typography>
                  <Typography className={subjectCount?.awaiting > 0 ? classes.errorValue : ''}>
                    {subjectCount?.awaiting}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Card>
  )
}

export default SubjectCard

export const AttendeeSubjectCard = ({ title, type, subjectCount, selectedType }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  return (
    <Card
      elevation={0}
      variant="outlined"
      className={selectedType === type ? classes.selectedPaper : classes.paper}>
      <Box
        onClick={() => {
          dispatch(subjectSlice.actions.setSubjectType(type))
          if (subjectCount.pending > 0) {
            dispatch(subjectSlice.actions.setSubjectStatusFilter(SubjectStatus.INVITE_NOT_SENT))
          } else if (subjectCount.invited > 0) {
            dispatch(subjectSlice.actions.setSubjectStatusFilter(SubjectStatus.AWAITING_RESPONSE))
          } else {
            dispatch(subjectSlice.actions.setSubjectStatusFilter('All'))
          }
        }}>
        <Typography className={classes.title}>
          <People />
          {title}
        </Typography>

        <Box sx={{ marginTop: '10px', gap: '0.3rem' }}>
          <Box className={classes.info}>
            <Typography className={classes.label}>Invite not sent : </Typography>
            <Typography className={subjectCount?.pending > 0 ? classes.errorValue : ''}>
              {subjectCount?.pending}
            </Typography>
          </Box>
          <Box className={classes.info}>
            <Typography className={classes.label}>Awaiting response : </Typography>
            <Typography className={subjectCount?.invited > 0 ? classes.errorValue : ''}>
              {subjectCount?.invited}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  )
}

const useStyles = makeStyles({
  paper: {
    cursor: 'pointer',
    padding: '10px',
    '&:hover': {
      backgroundColor: '#e0f7fa'
    }
  },
  selectedPaper: {
    cursor: 'pointer',
    backgroundColor: '#e0f7fa',
    padding: '10px'
  },
  attendeeCard: {
    paddingTop: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e0f7fa',
      border: 'none'
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
    fontSize: '16px',
    fontWeight: 'bold',
    color: colors.indigo
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  label: {
    whiteSpace: 'nowrap',
    fontSize: '13px',
    fontWeight: 'bold'
  },
  errorValue: {
    fontSize: '13px',
    color: '#ff0000'
  },
  successValue: {
    fontSize: '13px',
    color: '#43a047'
  },
  actionButtons: {
    display: 'flex',
    gap: '1rem',
    padding: '0.5rem 0.75rem',
    backgroundColor: 'transparent'
  },
  count: {
    fontSize: '14px',
    fontWeight: '550'
  },
  errorBtn: {
    color: '#ee0606',
    textTransform: 'none',
    cursor: 'pointer'
  }
})
